import { PrintExampleDto2 } from '@/api-sdk';

/**
 * Type guard to check if PrintExampleDto has all required string properties for PrintExampleType.
 * Validates that filename and url are both non-null strings.
 */
export function isPrintExampleType(
  printExampleData: PrintExampleDto2 | null | undefined,
): printExampleData is { uuid: string; filename: string; url: string } {
  return Boolean(
    printExampleData &&
    typeof printExampleData.filename === 'string' &&
    typeof printExampleData.url === 'string',
  );
}
